import * as React from "react";
import { Stack, Pivot, PivotItem } from "office-ui-fabric-react";
import { useHistory } from "react-router-dom";
import AuditLogTab from "./AuditLogTab";
import AuthLogTab from "./AuthLogTab";
import { childrenGap8 } from "../common/Constants";
import PageTitle from "../common/PageTitle";
import AuditLogIcon from "../../images/audit-logs-icon.svg";

const AuditLogsMain: React.FC = () => {
  // state
  const [state, setState] = React.useState({
    selectedKey: "audit",
  });

  // custom hooks
  const history = useHistory();

  React.useEffect(() => {
    let hash = window.location.hash;
    if (hash) {
      hash = hash.substr(1);
      setState({
        selectedKey: hash,
      });
    }
  }, [window.location.hash]);

  const _getTabId = (itemKey: string): string => {
    return `${itemKey}`;
  };

  const handleTabChange = (item?: PivotItem) => {
    const key = item?.props.itemKey || "audit";
    setState({ selectedKey: key });
    history.push(window.location.pathname + "#" + key);
  };

  return (
    <React.Fragment>
      <Stack tokens={childrenGap8}>
        <Stack.Item>
          <PageTitle
            icon={AuditLogIcon}
            title="Security Audit & Activity Trails"
            description="Comprehensive oversight of system-wide activities, including administrative changes, data modifications, and secure authentication forensics."
          />
        </Stack.Item>
        <Stack.Item>
          <Pivot
            onLinkClick={handleTabChange}
            getTabId={_getTabId}
            selectedKey={state.selectedKey}
          >
            <PivotItem itemKey="audit" headerText="Audit Logs">
              <AuditLogTab />
            </PivotItem>
            <PivotItem itemKey="auth" headerText="Authentication Logs">
              <AuthLogTab />
            </PivotItem>
          </Pivot>
        </Stack.Item>
      </Stack>
    </React.Fragment>
  );
};

export default AuditLogsMain;
